import { useIntl } from 'react-intl';
import { Box, Chip, Tooltip } from '@material-ui/core';
import WarningIcon from '@material-ui/icons/Warning';

interface TripOrderCellProps {
  orderNumber?: string | null;
  orderMissing?: boolean;
}

// Shows the work order a trip is invoiced under and flags trips that the
// backend reports as missing an eligible order.
const TripOrderCell = ({ orderNumber, orderMissing }: TripOrderCellProps) => {
  const intl = useIntl();

  return (
    <Box
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
      gridGap={6}
    >
      <span>{orderNumber || '—'}</span>
      {orderMissing && (
        <Tooltip
          title={intl.formatMessage({
            id: 'BUSINESS_TRIP.WORK_ORDER.MISSING_TOOLTIP',
          })}
        >
          <Chip
            size="small"
            color="secondary"
            icon={<WarningIcon fontSize="small" />}
            label={intl.formatMessage({
              id: 'BUSINESS_TRIP.WORK_ORDER.MISSING',
            })}
          />
        </Tooltip>
      )}
    </Box>
  );
};

export default TripOrderCell;
